<template id="item">
    <div class="vx-row">
         <!-- <vs-divider>
            <h6>{{label}}</h6>
        </vs-divider> -->
        <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
            <vs-input class="w-full" v-validate="'required'" :label="label" type="number" v-model="item.amount" name="amount"/>
            <span class="text-danger" v-show="errors.has(`${vvFormScope}.amount`)">{{ errors.first(`${vvFormScope}.amount`) }}</span>
        </div>    
        <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
        <p class="m-base">{{ (item.amount*item.value).toFixed(2) + "€"}}</p>
            <!-- <vs-input
            class="w-full"
            v-validate="'required'"
            :label="$t('Price') |ToUppercase"
            type="number"
            v-model="item.price"
            name="price"
            /> -->
            <span class="text-danger" v-show="errors.has(`${vvFormScope}.price`)">{{ errors.first(`${vvFormScope}.price`) }}</span>
        </div>
    </div>
</template>
<script>
export default {
  inject: ["$validator"],
  name: "report-item-component",
  template: "#item",
  props: {
    item: {
      type: Object
    },
    vvFormScope: {
      type: String
    },
    label: {
        type: String
    }
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  }
};
</script>